import { render, staticRenderFns } from "./Allocations.vue?vue&type=template&id=5e1d7490&scoped=true&"
import script from "./Allocations.vue?vue&type=script&lang=js&"
export * from "./Allocations.vue?vue&type=script&lang=js&"
import style0 from "./Allocations.vue?vue&type=style&index=0&id=5e1d7490&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1d7490",
  null
  
)

export default component.exports